import {Box, Typography, useTheme, useMediaQuery} from '@mui/material'
import Form from './Form';

const LoginPage = () => {
    const theme = useTheme();
  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");

    return (
        <Box
          sx={{
            position: "relative",
            minHeight: "100vh",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: "url('https://www.shutterstock.com/image-vector/blue-white-abstract-ocean-texture-600nw-2615884913.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "blur(8px)",
              transform: "scale(1.1)",
              zIndex: -1,
            }
          }}
        >
        <Box width="100%" bgcolor="transparent" textAlign="center" sx={{ position: "relative", zIndex: 1, mb: "1rem" }}>
            <Typography
          fontWeight="bold"
          fontSize="32px"
          color="primary"
        >
          Dropie
        </Typography>
        </Box>

        <Box width={isNonMobileScreens?"50%":"93%"} p="2rem" borderRadius="1.5rem" bgcolor={theme.palette.background.alt} sx={{ position: "relative", zIndex: 1, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)", mb: "4rem" }}>
            <Typography fontWeight="500" variant='h5' sx={{mb:"1.5rem"}}>
                Welcome to Dropie
            </Typography>
            <Form/>
        </Box>
        </Box>
    )
}

export default LoginPage